import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDownloadPengurusKabkot,
  getDownloadPengurusPusat,
} from "../../../config/Redux/Download/actions";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close"; // Fixed Import

export default function BasicTable(param) {
  const dispatch = useDispatch();

  const dataDetail = useSelector((state) => state.download);
  // dataDetail?.downloadPengurusProvinsi?.data?.sort((a, b) => a?.data_diri?.id_jabatan > b?.data_diri?.id_jabatan ? 1 : -1);
  dataDetail?.downloadPengurusKabkot?.data?.sort(function (a, b) {
    if (a?.tingkat_exco?.id_provinsi === b?.tingkat_exco?.id_provinsi) {
      if (a?.tingkat_exco?.id_kabkot === b?.tingkat_exco?.id_kabkot) {
        return a.data_diri?.id_jabatan - b.data_diri?.id_jabatan;
      }
      return a.tingkat_exco?.id_kabkot - b.tingkat_exco?.id_kabkot;
    }
    return a?.tingkat_exco?.id_provinsi > b?.tingkat_exco?.id_provinsi ? 1 : -1;
  });
  let ketum = "";
  let sekjen = "";
  dataDetail?.downloadPengurusPusat?.data?.map((a) => {
    if (a?.data_diri?.id_jabatan === 7) {
      ketum = a?.data_diri?.nama;
    }
    if (a?.data_diri?.id_jabatan === 9) {
      sekjen = a?.data_diri?.nama;
    }
    return a;
  });
  // console.log(dataDetail)
  useEffect(() => {
    dispatch(getDownloadPengurusKabkot("", "", "", ""));
    dispatch(getDownloadPengurusPusat());
  }, [dispatch]);

  const convertDate = (time) => {
    let date = new Date(time);
    let month = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    return `${(date.getDate() < 10 ? "0" : "") + date.getDate()} ${
      month[date.getMonth()]
    } ${date.getFullYear()}`;
  };

  const exportToWord = async (element, filename) => {
    let css =
      "<style>@page download-paper{size: 8.27in 11.69in;mso-page-orientation: portrait;margin:0.75in 0.50in 0.75in 0.50in;} div.download-paper {page: download-paper;} </style>";
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>" +
      css +
      "</head><body>";
    var postHtml = "</body></html>";
    var html = preHtml + document.getElementById(element).innerHTML + postHtml;

    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    // Specify link url
    var url =
      "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    // Specify file name
    filename = filename ? filename + ".doc" : "document.doc";

    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  let alphabet = "abcdefghijklmnopqrstuvwxyz".split("");
  let tempCount = 0;
  let temp = 0;
  // let tempidx=0;
  const unique = [
    ...new Set(
      dataDetail?.downloadPengurusKabkot?.data?.map(
        (item) => item?.tingkat_exco?.nama_provinsi,
      ),
    ),
  ]; // [ 'A', 'B']
  // console.log(unique)
  return (
    <>
      <div className="download-page">
        {/* Premium Header - Dark Blue Gradient */}
        <div
          id="premium-download-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 32px",
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            position: "sticky",
            top: 0,
            zIndex: 100,
          }}
        >
          {/* Left - Title */}
          <div>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#ffffff",
                margin: 0,
                letterSpacing: "0.5px",
              }}
            >
              Susunan Pengurus Tingkat Kab/Kota
            </h2>
            <p
              style={{
                fontSize: 13,
                color: "rgba(255, 255, 255, 0.7)",
                margin: "6px 0 0",
                fontWeight: 400,
              }}
            >
              Partai Buruh
            </p>
          </div>

          {/* Right - Action Buttons */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() =>
                exportToWord("download-paper", "Pengurus Kab-Kota")
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "10px 20px",
                backgroundColor: "#4caf50",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                transition: "all 0.2s ease",
                color: "#ffffff",
                fontSize: 14,
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#43a047";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#4caf50";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <DownloadIcon style={{ fontSize: 20 }} />
              Download
            </button>

            <button
              onClick={() => param.setOpenDownload(false)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: 12,
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
              }}
            >
              <CloseIcon style={{ fontSize: 22, color: "#ffffff" }} />
            </button>
          </div>
        </div>
        <div id="download-paper">
          <div className="download-paper">
            <div style={{ textAlign: "center" }}>
              PARTAI POLITIK TINGKAT PUSAT <br />
              PARTAI BURUH
            </div>
            <br />
            <div style={{ textAlign: "center" }}>
              DAFTAR SUSUNAN PENGURUS DAN ALAMAT <br />
              PARTAI POLITIK TINGKAT KABUPATEN/KOTA
              <br />
              (PALING SEDIKIT 75% JUMLAH KABUPATEN/KOTA)
            </div>
            <br />
            <br />
            {unique?.map((list2, index) => {
              let arrData2 = [];
              arrData2 = dataDetail?.downloadPengurusKabkot?.data.filter(
                function (el) {
                  return el?.tingkat_exco?.nama_provinsi === list2;
                },
              );
              // tempidx = 0;
              temp = 0;
              return (
                <div
                  key={index}
                  className="download-table"
                  style={{ width: "100%" }}
                >
                  <br />
                  PROVINSI : {list2}
                  <table
                    frame="border"
                    cellSpacing="0"
                    cellPadding="0"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      border: "1px solid black",
                    }}
                  >
                    <thead>
                      <tr style={{ textAlign: "center" }}>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NO.
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          SUSUNAN PENGURUS
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "1px solid black",
                            maxWidth: "35mm",
                          }}
                        >
                          NAMA
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NO. KARTU TANDA ANGGOTA
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NIK
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NOMOR SURAT KEPUTUSAN
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          ALAMAT KANTOR
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {arrData2?.map((list, idx, arr) => {
                        const prevValue = arr[idx - 1];
                        let arrData = [];
                        // if(list?.data_diri?.id_jabatan === 1 || list?.data_diri?.id_jabatan === 3 || list?.data_diri?.id_jabatan === 5){
                        let flag = false;
                        if (
                          prevValue?.tingkat_exco?.id_kabkot !==
                          list?.tingkat_exco?.id_kabkot
                        ) {
                          flag = true;
                          temp++;
                          tempCount = 0;
                          // tempidx = idx;
                          arrData = arr.filter(function (el) {
                            if (
                              el?.data_diri?.id_jabatan === 1 ||
                              el?.data_diri?.id_jabatan === 3 ||
                              el?.data_diri?.id_jabatan === 5
                            ) {
                              return (
                                el?.tingkat_exco?.id_kabkot ===
                                list?.tingkat_exco?.id_kabkot
                              );
                            } else {
                              return null;
                            }
                          });
                        }
                        if (
                          list?.data_diri?.id_jabatan === 1 ||
                          list?.data_diri?.id_jabatan === 3 ||
                          list?.data_diri?.id_jabatan === 5
                        ) {
                          tempCount++;
                          return (
                            <>
                              {flag ? (
                                <tr key={idx + "-head"}>
                                  <td
                                    style={{
                                      padding: "4px",
                                      verticalAlign: "top",
                                      borderBottom: "1px solid black",
                                      borderRight: "1px solid black",
                                      textAlign: "center",
                                    }}
                                    rowSpan={arrData?.length + 1}
                                  >
                                    {temp}
                                  </td>
                                  <td
                                    style={{
                                      padding: "4px",
                                      verticalAlign: "top",
                                      borderTop: "1px solid black",
                                      borderRight: "1px solid black",
                                    }}
                                  >
                                    <div>
                                      Kab/Kota : <br />{" "}
                                      {list?.tingkat_exco?.nama_kab_kot}
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      padding: "4px",
                                      borderTop: "1px solid black",
                                      borderRight: "1px solid black",
                                    }}
                                  ></td>
                                  <td
                                    style={{
                                      padding: "4px",
                                      borderTop: "1px solid black",
                                      borderRight: "1px solid black",
                                    }}
                                  ></td>
                                  <td
                                    style={{
                                      padding: "4px",
                                      borderTop: "1px solid black",
                                      borderRight: "1px solid black",
                                    }}
                                  ></td>
                                  <td
                                    style={{
                                      padding: "4px",
                                      verticalAlign: "top",
                                      borderBottom: "1px solid black",
                                      borderRight: "1px solid black",
                                      maxWidth: "25mm",
                                      overflowWrap: "break-word",
                                    }}
                                    rowSpan={arrData?.length + 1}
                                  >
                                    {list?.kantor?.nomer_sk_pengurus}
                                  </td>
                                  <td
                                    style={{
                                      padding: "4px",
                                      verticalAlign: "top",
                                      borderBottom: "1px solid black",
                                      maxWidth: "25mm",
                                      overflowWrap: "break-word",
                                    }}
                                    rowSpan={arrData?.length + 1}
                                  >
                                    {list?.kantor?.alamat_detail} RT/RW{" "}
                                    {list?.kantor?.alamat_rt}/
                                    {list?.kantor?.alamat_rw},
                                    {list?.kantor?.alamat_kelurahan},
                                    {list?.kantor?.alamat_kecamatan},
                                    {list?.kantor?.alamat_kab_kot},
                                    {list?.kantor?.alamat_provinsi}
                                  </td>
                                </tr>
                              ) : null}
                              <tr key={idx}>
                                <td
                                  style={{
                                    padding: "4px",
                                    borderRight: "1px solid black",
                                    minWidth: "115pt",
                                  }}
                                >
                                  {alphabet[tempCount - 1]}.{" "}
                                  {list?.data_diri?.nama_jabatan}
                                </td>
                                <td
                                  style={{
                                    padding: "4px",
                                    borderRight: "1px solid black",
                                    maxWidth: "35mm",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {list?.data_diri?.nama}
                                </td>
                                <td
                                  style={{
                                    padding: "4px",
                                    borderRight: "1px solid black",
                                    textAlign: "center",
                                  }}
                                >
                                  {list?.data_diri?.no_kta}
                                </td>
                                <td
                                  style={{
                                    padding: "4px",
                                    borderRight: "1px solid black",
                                    overflowWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                >
                                  {list?.data_diri?.nik}
                                </td>
                              </tr>
                            </>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </tbody>
                  </table>
                </div>
              );
            })}

            <br />
            <br />
            <div style={{ textAlign: "right" }}>
              Jakarta, {convertDate(new Date())}
            </div>
            <br />
            <div style={{ textAlign: "center" }}>
              PIMPINAN PARTAI POLITIK TINGKAT PUSAT
              <br />
              PARTAI BURUH
            </div>
            <br />
            <br />
            <div style={{ textAlign: "center" }}>
              <table style={{ width: "100%", textAlign: "center" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "center" }}>
                      Presiden
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      {ketum}
                    </td>
                    <td style={{ width: "50%", textAlign: "center" }}>
                      Sekretaris Jenderal
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      {sekjen}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
